//获取用户简历
import { request } from "@/utils/response";
export async function GetUserResumes() {
    return request(`/v1/user/resumeFiles`, {
        method: "POST",
    });
}
//发送附件简历
export async function SendAttachmentCv(data) {
    return request(`/v1/user/post_resume`, {
        method: "POST",
        data,
    });
}
export const sendChatResume = async (data) => {
    return request(`/v1/user/oneClickPostResume`, {
        method: "POST",
        data,
    });
};
//上传附件简历
export async function UploadAttachmentCv(data) {
    return request(`/v1/media/upload/resume`, {
        method: "POST",
        data: data,
        timeout: 60000,
        arguments: {
            headers: {
                "Content-Type": "multipart/form-data",
            },
            prefix: "/media",
        },
    });
}
